!(function ($) {
    $.fn.eqHeight = function ($bounds) {
        var $els = $(this);
        var elLength = $els.length;
        var $bounds = $bounds || $els.parent();

        if (typeof ($bounds) === "number") {
            cols = $bounds;
        } else {
            var containerWidth = $bounds.width(),
                boxWidth = $els.eq(0).width(),
                cols = Math.floor(containerWidth / boxWidth);
        }

        var height, i, l, j;

        if (cols > 1) {
            $els.css({ height: 'auto', minHeight: 0 });

            for (i = 0, l = elLength; i < l; i += cols) {
                height = 0;

                for (j = 0; j < cols; j++) {
                    if ($els.eq(i + j).length) {
                        height = Math.max(height, $els.eq(i + j).outerHeight());
                    }
                }

                height = Math.ceil(height);

                for (j = 0; j < cols; j++) {
                    $els.eq(i + j).height(height);
                }
            }
        }

        return $els;
    };

    Parsley.addMessages('pt-br', {
      defaultMessage: "Este valor parece ser inválido.",
      type: {
        email:        "Este campo deve ser um email válido.",
        url:          "Este campo deve ser um URL válida.",
        number:       "Este campo deve ser um número válido.",
        integer:      "Este campo deve ser um inteiro válido.",
        digits:       "Este campo deve conter apenas dígitos.",
        alphanum:     "Este campo deve ser alfa numérico."
      },
      notblank:       "Este campo não pode ficar vazio.",
      required:       "Este campo é obrigatório.",
      pattern:        "Este campo parece estar inválido.",
      min:            "Este campo deve ser maior ou igual a %s.",
      max:            "Este campo deve ser menor ou igual a %s.",
      range:          "Este campo deve estar entre %s e %s.",
      minlength:      "Este campo é pequeno demais. Ele deveria ter %s caracteres ou mais.",
      maxlength:      "Este campo é grande demais. Ele deveria ter %s caracteres ou menos.",
      length:         "O tamanho deste campo é inválido. Ele deveria ter entre %s e %s caracteres.",
      mincheck:       "Você deve escolher pelo menos %s opções.",
      maxcheck:       "Você deve escolher %s opções ou mais",
      check:          "Você deve escolher entre %s e %s opções.",
      equalto:        "Este valor deveria ser igual."
    });
    Parsley.setLocale('pt-br');
})(jQuery);

const $window   = $(window);
const $document = $(document);
const $body     = $('body');

let wW          = $window.outerWidth();
let wH          = $window.outerHeight();
let dH          = $document.outerHeight();

if (Is.mobile.ANY()) {
    $body.addClass('mobile');
} else {
    $body.addClass('desktop');
}

if (Is.desktop.MAC()) {
    $body.addClass('mac');
}

if(Is.desktop.IE()) {
    $body.addClass('ie');
}

if(Is.desktop.IE10()) {
    $body.addClass('ie10');
}

if(Is.desktop.IE11()) {
    $body.addClass('ie11');
}

if(Is.desktop.EDGE()) {
    $body.addClass('edge');
}

if(Is.desktop.CHROME()) {
    $body.addClass('chrome');
}

if(Is.desktop.FIREFOX()) {
    $body.addClass('firefox');
}

if(Is.desktop.SAFARI()) {
    $body.addClass('safari');
}

$document.on('preloaded.after', function () {
    $window
        .on('scroll', function () {
            if (!Is.mobile.ANY()) {
                Animator.onScroll();
            }
        })
        .trigger('scroll');
});

$document.on('preloaded.before', function () {
    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();

            const colFooter = '.prime-infos .base';
            $(colFooter).find('span').eqHeight(3);

            if (wW < 769) {
                if (slickIndex) {
                    $('.products').slick('slickGoTo', slickIndex);
                }
                // $('#products .product-item').on('click', function(){
                //     var $this = $(this);
                //     $('#products .product-item').removeClass('clicked');
                //     $this.toggleClass('clicked');
                //     $('.products').toggleClass('clicked');
                // });

                $('#products .product-item').addClass('clicked');
                $('.products').addClass('clicked');
            } else {
                $('#products .product-item').removeClass('clicked');
                const $keep         = $('.keepClicked');
                const $productItens = $('#products .product-item');

                $productItens.hover(
                    function() {
                        var $this = $(this);
                        $productItens.removeClass('clicked');
                        $keep.removeClass('keepClicked');
                        $this.addClass('clicked');
                    }, function() {
                        var $this = $(this);
                        $this.removeClass('clicked');
                        $keep.addClass('keepClicked').addClass('clicked');
                    }
                );

                if ($keep.length > 0) {
                    $keep.addClass('clicked');
                }

                setTimeout(function(){
                    const postHeader = '.post-header';
                    $(postHeader).find('> div').eqHeight(2);
                }, 200);
            }
        });

    Component.init();

    if (typeof Navigation !== 'undefined') { Navigation.init(); }
    if (typeof Ticker !== 'undefined') { Ticker.init(); }

    if (scrollToProduct === true) {
        Navigation.helpers.scrollTo($('section#productContent'));
    }

    $window.trigger('resize');
});


$body.waitForImages(true)
    .progress((loaded, count, success) => {
        count++;

        let percent = (loaded * 100 / count);

        TweenMax.to('.preloader__bar__progress', .6, { width: percent+'%', ease: Expo.easeInOut});
    })
    .done(() => {
        TweenMax.to('.preloader__bar__progress', .6, { width: '100%', onComplete: () => {
            $document.trigger('preloaded.before');

            TweenMax.to('.preloader', .4, { opacity: 0, display: 'none', onComplete: () => $document.trigger('preloaded.after') });
        } });
    });
